import React, { useState } from "react";
import styled from "styled-components";

// import ChevronDown from "../../globals/icons/ChevronDown";
import NewWindowOpen from "../../globals/icons/NewWindowOpen";
import ArrowRight from "../../globals/icons/ArrowRight";
import LearnSectionWrapper from "./LearnSectionWrapper";

import { StyledSubTitle2, StyledDesc2, StyledDescTag } from "../shared/StyledTypography";
import { textUppercase, transition, ptb32, removePaddTop } from "../shared/CommonStyled";
import { COLORS } from "../../globals/designSystem";
import { mq } from "../../globals/utils";
import { Image } from '../../globals/UIKit';

// import shadow from "./images/shadow.png";

const StyledTutorialWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 48px;
  .textEllipsis {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* number of lines to show */
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 140px;
  }
  .learnListWrapper {
    position: relative;
    .shadow {
      position: absolute;
      bottom: 0px;
      width: 100%;
      margin-left: -18px;
    }
    .showArrow {
      text-align: center;
      position: relative;
      position: absolute;
      bottom: -14px;
      width: 100%;
      .cursorPoiter {
        cursor: pointer;
        ${transition}
      }
      .rotateImg {
        transform: rotate(180deg);
      }
    }
    .posBot {
      bottom: -24px;
    }
  }
  .courseWrapper {
    ul {
      li {
        align-items: center;
        padding: 8px 0;
        display: block;
        &:first-child {
          padding-top: 8px;
        }
        &:last-child {
          padding-bottom: 0;
        }
        a {
          display: flex;
          align-items: center;
          img {
            margin-right: 16px;
            width: 24px;
          }
          .arrow {
            margin-left: 6px;
          }
        }
        .courseDesc {
          padding-top: 8px;
          padding-bottom: 12px;
          position: relative;
          .shadow {
            position: absolute;
            bottom: 0px;
            width: 100%;
            margin-left: -18px;
          }
          .showArrow {
            text-align: center;
            position: relative;
            position: absolute;
            bottom: -14px;
            width: 100%;
            .cursorPoiter {
              cursor: pointer;
              ${transition}
            }
            .rotateImg {
              transform: rotate(180deg);
            }
          }
          .posBot {
            bottom: -16px;
          }
        }
        .courseDescEllipsis {
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2; /* number of lines to show */
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }
  }
  .introCourse {
    ul {
      li {
        padding: 4px 0;
        ::marker {
          color: ${COLORS.sky_80};
        }
        a {
          display: flex;
          align-items: center;
          .arrow {
            margin-top: 2px;
            margin-left: 6px;
          }
        }
      }
    }
  }
  ${mq.below.md} {
    grid-template-columns: 1fr;
    grid-gap: 24px;
  }
`;

const Tutorials = ({tutorialList, graphqlPage, removeTopPadd}) => {
  const [showList] = useState(tutorialList.isOpenDesc);
  // const [learnCourseDetail, setLearnCourseDetail] = useState(tutorialList.learnCourse);

  // const showAnswer = (index) => {
  //   const newLearnCourseDetail = [...learnCourseDetail];
  //   newLearnCourseDetail[index].courseDescOpen = !learnCourseDetail[index].courseDescOpen;
  //   setLearnCourseDetail(newLearnCourseDetail);
  // };
  // const onClickSL = () => {
  //   setShowList(prevList=>!prevList)
  // }
  return (
    <LearnSectionWrapper id={graphqlPage ? tutorialList.id : ""} className={((tutorialList.removeBor) ? "removeBorBottom" : "")} css={(graphqlPage ? ptb32 : null) + ' ' + (removeTopPadd ? removePaddTop : null)}>
      <StyledTutorialWrapper>
        <div>
          <StyledSubTitle2 paddingBottom="pb8">{tutorialList.title}</StyledSubTitle2>
          {
            graphqlPage ? (
              <StyledDesc2 paddingBottom="pb24">{tutorialList.graphqlDesc}</StyledDesc2>
            ) : (
              <StyledDesc2 paddingBottom="pb24">{tutorialList.desc}</StyledDesc2>
            )
          }
          {
            tutorialList.learnList && !graphqlPage? (
              <>
                <StyledDescTag paddingBottom="pb16" fontWeight="font_600" css={textUppercase}>What you’ll learn:</StyledDescTag>
                <StyledDesc2>
                  <ul className={"discUl learnListWrapper" + ((showList) ? "" : " textEllipsis")}>
                    {
                      tutorialList.learnList.map((item, index) => (
                        <li key={index} className="disc">{item}</li>
                      ))
                    }
                    {/*
                    <Image className={"shadow"} css={showList ? hideTab : showTab} src={shadow} alt="Shadow" />
                    <div className={"showArrow" + ((showList) ?  " posBot" : "")}>
                      <ChevronDown onClickSL={onClickSL} variant="grey_100" size="md" className={"cursorPoiter" + ((showList) ?  " rotateImg" : "")}/>
                    </div>
                    */}
                  </ul>
                </StyledDesc2>
              </>
            ) : null
          }
          {
            tutorialList.introGraphQL ? (
              <StyledDesc2 className="introCourse">
                <ul className="discUl">
                  {
                    tutorialList.introGraphQL.map((item, index) => (
                      <li key={index} className="disc">
                        <a href={item.courseLink}>{item.courseName}<NewWindowOpen className="rightIcon" variant="sky_80" size="sm"/></a>
                      </li>
                    ))
                  }
                </ul>
              </StyledDesc2>
            ) : null
          }
        </div>
        <div className="courseWrapper">
          <StyledDesc2>
            <ul>
              {
                tutorialList.learnCourse.map((course, index) => (
                  <li key={index}>
                    <a href={course.courseLink}>
                      {course.imgSrc ? <Image src={course.imgSrc} alt={course.courseName} height="24" width="24" /> : null}{course.courseName}<ArrowRight variant="sky_80" size="xs" className="arrow"/>
                    </a>
                    {
                      course.courseDesc && !graphqlPage ? (
                        <div className={"courseDesc" + ((course.courseDescOpen) ? "" : " courseDescEllipsis")}>
                          {course.courseDesc}
                          {/*
                          <Image className={"shadow"} css={course.courseDescOpen ? hideTab : showTab} src={shadow} alt="Shadow" />
                          <div className={"showArrow" + ((course.courseDescOpen) ?  " posBot" : "")}>
                            <ChevronDown variant="grey_100" size="md" className={"cursorPoiter" + ((course.courseDescOpen) ?  " rotateImg" : "")}
                              ole="button"
                              tabIndex="0"
                              onKeyDown={() => showAnswer(index)}
                              onClickSL={() => showAnswer(index)}
                            />
                          </div>
                          */}
                        </div>
                      ) : null
                    }
                  </li>
                ))
              }
            </ul>
          </StyledDesc2>
        </div>
      </StyledTutorialWrapper>
    </LearnSectionWrapper>
  );
};

export default Tutorials;
